export default "__VITE_PUBLIC_ASSET__fbf8bbed__"